import { render } from "./AddExternalPortalLink.vue?vue&type=template&id=52c23693"
import script from "./AddExternalPortalLink.vue?vue&type=script&lang=js"
export * from "./AddExternalPortalLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__